const initialState = {
  status: "invalid",
  data: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ABSENCES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ABSENCES_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "ABSENCES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
